import React, {useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import MailPropertiesDetailDialog from "./MailPropertiesDetailDialog";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {MailPropertiesDto} from "../../../../../modules/mail/dto/MailPropertiesDto";
import {MailPropertiesApi} from "../../../../../modules/mail/api/MailPropertiesApi";
import {Card, CardHeader, IconButton, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import ModifyIconButton from "../../../../../components/buttons/ModifyIconButton";
import DeleteIconButton from "../../../../../components/buttons/DeleteIconButton";
import {useConfirm} from "material-ui-confirm";
import AddIconButton from "../../../../../components/buttons/AddIconButton";
import RefreshIconButton from "../../../../../components/buttons/RefreshIconButton";

export type MailPropertiesListProps = {
    onRefresh: () => void;
    mailPropertiesList: Array<MailPropertiesDto>;
};

const MailPropertiesList: React.FC<MailPropertiesListProps> = (props) => {
    const intl = useIntl();

    const confirm = useConfirm();

    const [openDetailModal, setOpenDetailModal] = useState(false);

    const [currentRow, setCurrentRow] = useState<MailPropertiesDto>(new MailPropertiesDto());

    const handleAdd = () => {
        setCurrentRow(new MailPropertiesDto());
        setOpenDetailModal(true);
    };

    const handleModify = async (record: MailPropertiesDto) => {
        const responseResult = await MailPropertiesApi.getMailPropertiesDetail(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCurrentRow(responseResult.data);
            setOpenDetailModal(true);
        }
    };

    const handleDelete = async (record: MailPropertiesDto) => {
        confirm({title: intl.formatMessage({id: 'COMMON_DELETE_CONFIRM'})})
            .then(async () => {
                const responseResult = await MailPropertiesApi.deleteMailProperties(record.id);
                if (responseResult.status === HttpStatus.SUCCESS) {
                    MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
                    props.onRefresh();
                }
            })
            .catch(() => {
                console.log('cancel');
            });
    };

    return (
        <Card>
            <MailPropertiesDetailDialog open={openDetailModal}
                                        onOk={() => props.onRefresh()}
                                        onClose={() => setOpenDetailModal(false)}
                                        mailProperties={currentRow}/>
            <CardHeader title={intl.formatMessage({id: 'MAIL_PROPERTIES'})}
                        action={
                            <div>
                                <AddIconButton onClick={handleAdd}/>
                                <RefreshIconButton onClick={() => props.onRefresh()}/>
                            </div>
                        }/>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{intl.formatMessage({id: 'MAIL_PROPERTIES_MAIL_HOST'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'MAIL_PROPERTIES_MAIL_FROM'})}</TableCell>
                        <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.mailPropertiesList.map((row, index) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.mailHost}</TableCell>
                            <TableCell>{row.mailFrom}</TableCell>
                            <TableCell>
                                <div>
                                    <ModifyIconButton onClick={() => handleModify(row)}/>
                                    <DeleteIconButton onClick={() => handleDelete(row)}/>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

        </Card>
    );
};

export default MailPropertiesList;
